module.exports = "<h1>Angular + Firebase + Stripe Payments</h1>\n\n<p>\n  A Full Stack Payment solution for Angular 5.x apps. \n</p>\n\n<p>\n  <a href=\"https://projects.angularfirebase.com/p/stripe-payments-with-angular-and-firebase\" target=\"_blank\">\n    Full Course\n  </a>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/read-me/read-me.component.html
// module id = ./src/app/demo/read-me/read-me.component.html
// module chunks = main